import { z } from 'zod'
import { WithExpiresAtSchema } from '../ttl'
import { UTCMillisecondsSchema } from '../time'
import { idSchemaV2, isId, UserIdSchema } from '../ids'
import { AuditPropsSchema } from '../common'

export const RecordingIdSchema = idSchemaV2('Recording')
export type RecordingId = z.infer<typeof RecordingIdSchema>
export const isRecordingId = isId(RecordingIdSchema)

export const UnsavedRecordingSchema = z.object({})

export const RecordingDataSchema = z.object({
  ...AuditPropsSchema.shape,
  ...UnsavedRecordingSchema.shape,
  ...WithExpiresAtSchema.partial().shape,
  ownerId: UserIdSchema,
  recordingId: RecordingIdSchema,
  startedAt: UTCMillisecondsSchema.optional(),
  connectedAt: UTCMillisecondsSchema.optional(),
  endedAt: UTCMillisecondsSchema.optional(),
  recordedDurationMs: z.number().int().nonnegative().optional(),
})

export type UnsavedRecording = z.infer<typeof UnsavedRecordingSchema>
export type RecordingData = z.infer<typeof RecordingDataSchema>

export const RecordingSegmentSequenceSchema = z.number().int().nonnegative()

export const UnsavedRecordingSegmentSchema = z.object({
  recordingId: RecordingIdSchema,
  sequence: RecordingSegmentSequenceSchema,
  contentType: z.string(),
})

export type UnsavedRecordingSegment = z.infer<typeof UnsavedRecordingSegmentSchema>

export const IceServerSchema = z.object({
  urls: z.array(z.string()),
  username: z.string(),
  password: z.string(),
  ttl: z.number(),
})
export type IceServer = z.infer<typeof IceServerSchema>
